<template>
  <Layout>
    <div class="page-padding page-padding-all">
      <DataBox :loading="false" :error="error">
        {{ title }}
      </DataBox>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layout/inside/index.vue'
import DataBox from '@/components/DataBox.vue'

export default {
  name: 'NotFound',
  components: { Layout, DataBox },
  data() {
    return {
      title: 'Страница не найдена, или у вас нет доступа.',
    }
  },
  computed: {
    error() {
      return new Error(this.title).message
    },
  },
}
</script>
